export enum VideoResolution {
  SD480 = "sd480",

  HD720 = "hd720",

  HD1080 = "hd1080",

  UHD4K = "uhd4k",
}

export const VIDEO_RESOLUTION_META: Record<
  VideoResolution,
  { label: string; width: number; height: number }
> = {
  [VideoResolution.SD480]: { label: "480p", width: 640, height: 480 },

  [VideoResolution.HD720]: { label: "720p", width: 1280, height: 720 },

  [VideoResolution.HD1080]: { label: "1080p", width: 1920, height: 1080 },

  [VideoResolution.UHD4K]: { label: "4K", width: 3840, height: 2160 },
};

export enum ScreenShareMode {
  FullScreen = "fullScreen",

  Application = "application",
}

export enum CaptureSource {
  Camera = "camera",

  ScreenWindow = "screenWindow",

  ScreenFull = "screenFull",

  Media = "media",

  Audio = "audio",

  AudioOnly = "audioOnly",
}

export interface CameraConfig {
  cameraId?: string;

  resolution: VideoResolution;

  fps: number;

  mirrorMode: boolean;
}

export const DEFAULT_CAMERA_CONFIG: CameraConfig = {
  resolution: VideoResolution.HD1080,

  fps: 60,

  mirrorMode: false,
};

export interface ScreenShareConfig {
  mode: ScreenShareMode;

  includeMicrophone: boolean;

  includeSystemAudio: boolean;

  fps: number;

  resolution: VideoResolution;
}

export const DEFAULT_SCREEN_SHARE_CONFIG: ScreenShareConfig = {
  mode: ScreenShareMode.FullScreen,

  includeMicrophone: false,

  includeSystemAudio: false,

  fps: 60,

  resolution: VideoResolution.HD1080,
};

export interface StreamMetrics {
  currentFps: number;

  currentResolution: string;

  bitrate: number; // kbps

  droppedFrames: number;

  uptimeSeconds: number;
}

export const EMPTY_METRICS: StreamMetrics = {
  currentFps: 0,

  currentResolution: "-",

  bitrate: 0,

  droppedFrames: 0,

  uptimeSeconds: 0,
};

export interface MediaSelection {
  file: File;

  isVideo: boolean;
}

export const FPS_OPTIONS = [
  { value: 24, label: "24 FPS", description: "Film Standard" },

  { value: 30, label: "30 FPS", description: "Standard" },

  { value: 60, label: "60 FPS", description: "High Performance" },
] as const;
